/**
 * 时间转换
 * @param dateToFormat
 * @returns {*}
 */
export function formatDate(dateToFormat) {
  let format = "暂无日期";
  if (dateToFormat) {
    let time = new Date(dateToFormat);
    let mo = time.getMonth() + 1,
      d = time.getDate(),
      h = time.getHours(),
      mi = time.getMinutes();

    format = `${mo}月${d}日 ${h}:${mi < 10 ? "0" + mi : mi}`;
  }

  return format;
}

/**
 * 时间转换2
 * @param dateToFormat
 * @returns {*}
 */
export function formatDate2(dateToFormat) {
  let time = new Date(dateToFormat);
  let mo = time.getMonth() + 1,
    d = time.getDate(),
    h = time.getHours(),
    mi = time.getMinutes(),
    s = time.getSeconds();

  let format = `${mo}/${d} ${h}:${mi < 10 ? "0" + mi : mi}:${
    s < 10 ? "0" + s : s
  }`;
  return format;
}

//年月日时分秒
export function formatDate3(dateToFormat) {
  let time = new Date(dateToFormat);
  let Y = time.getFullYear();
  let M =
    time.getMonth() + 1 - 0 >= 10
      ? Number(time.getMonth()) + 1
      : "0" + (Number(time.getMonth()) + 1);
  let D = time.getDate();
  let h = time.getHours() >= 10 ? time.getHours() : "0" + time.getHours();
  let m = time.getMinutes() >= 10 ? time.getMinutes() : "0" + time.getMinutes();
  let s = time.getSeconds() >= 10 ? time.getSeconds() : "0" + time.getSeconds();
  return Y + "-" + M + "-" + D + " " + h + ":" + m + ":" + s;
}

// 图片json字符串转数组取第一张图片
export function getImgsOne(imgs) {
  if (imgs) {
    return JSON.parse(imgs)[0];
  } else {
    return "";
  }
}

// 密码中等判断,6~10位的数字+字母；字母+特殊字符，特殊字符+数字
export function passwordVerification(password) {
  let reg = /^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$).{8,20}$/;
  // console.log(password, reg.test(password)); // true
  return reg.test(password);
}


export function getUrlParam(param) {
  // 获取由全部参数组成的字符串。
  let query = window.location.search.substring(1);
  // 分割参数，得到每一个参数字符串组成的数组。
  let vars = query.split('&');
  // 遍历数组，得到每一个参数字符串。
  for (let i = 0; i < vars.length; i++) {
      // 分割每一个参数字符串，得到参数名和参数值组成的数组。
      var pair = vars[i].split('=');
      // 如果参数名等于传入的param，则返回该值。
      if (pair[0] == param) {
          return decodeURI(pair[1]);
      }
  }
  // 若参数不存在，则返回false。
  return false;
}
